import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Products from './pages/Products';
import CaseManagement from './pages/CaseManagement';
import Consultancy from './pages/Consultancy';
import Support from './pages/Support';
import Company from './pages/Company';
import Solutions from './pages/Solutions';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/case-management" element={<CaseManagement />} />
        <Route path="/consultancy" element={<Consultancy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/company" element={<Company />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={
          <div className="container section">
            <h1>Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
          </div>
        } />
      </Routes>
    </Layout>
  );
}

export default App;
